import { ICancelElectronicInvoice, ILoginVNPay, IReleaseElectronicInvoice, ISearchInvoiceVNPAY, ISenCQTElectronicInvoice, ISignElectronicInvoice, IUploadInfoRequest, IViewPDFElectronicInvoice } from "../dataType/ElectronicInvoice";
import client from "./apiConfig";
import { Invoice } from "../dataType/Invoice";
import { IUploadFile } from "../views/ElectronicInvoice/AccountElectronicInvoce/VNPay/FormRegister";
import { ELECTRONIC_INVOICE_VALUE } from "../constants/mock";

export default {
  getEndpoint(type?: number) {
    switch (type) {
      case ELECTRONIC_INVOICE_VALUE.VNPAY:
        return "/pharmacy/invoice/vnpay";
      case ELECTRONIC_INVOICE_VALUE.HILO:
        return "/pharmacy/invoice/hilo";
      default:
        return "";
    }
  },

  async getElectronicInvoices(params: ISearchInvoiceVNPAY) {
    const res = await client.get('/pharmacy/invoice/einvoice', { params });
    return res.data;
  },

  async cancelElectronicInvoice(payload: ICancelElectronicInvoice, type?: number) {
    const endpoint = this.getEndpoint(type);
    const res = await client.put(`${endpoint}/cancel`, payload);
    return res.data;
  },

  async releaseElectronicInvoice(payload: IReleaseElectronicInvoice , type?: number) {
    const endpoint = this.getEndpoint(type);
    const res = await client.put(`${endpoint}/update`, payload);
    return res.data;
  },

  async signElectronicInvoice(payload: ISignElectronicInvoice, type?: number) {
    const endpoint = this.getEndpoint(type);
    const res = await client.put(`${endpoint}/update`, payload);
    return res.data;
  },

  async sendCQTElectronicInvoice(payload: ISenCQTElectronicInvoice, type?: number) {
    const endpoint = this.getEndpoint(type);
    const res = await client.put(`${endpoint}/update`, payload);
    return res.data;
  },

  async createElectronicInvoice(payload: Invoice, posVatInvOriginCode: string, type?: number) {
    const endpoint = this.getEndpoint(type);
    const res = await client.post(`${endpoint}/create`, {
      invoice: payload,
      pos_vat_inv_original_code: posVatInvOriginCode,
    });
    return res.data;
  },

  async viewPDFElectronicInvoice(params: IViewPDFElectronicInvoice, type?: number) {
    const endpoint = this.getEndpoint(type);
    const res = await client.get(`${endpoint}/pdf`, { params });
    return res.data;
  },

  async loginVNPay(payload: ILoginVNPay) {
    const res = await client.post("/pharmacy/invoice/vnpay/connect", payload);
    return res.data;
  },

  async loginHilo(payload: ILoginVNPay) {
    const res = await client.post("/pharmacy/invoice/hilo/connect", payload);
    return res.data;
  },

  async disconnectVNPay(payload: { drg_store_id: number }) {
    const res = await client.post("/pharmacy/invoice/vnpay/disconnect", payload);
    return res.data;
  },

  async disconnectHilo(payload: { drg_store_id: number }) {
    const res = await client.post("/pharmacy/invoice/hilo/disconnect", payload);
    return res.data;
  },

  async sendEmailVNPay(vnpayInfo: IUploadInfoRequest, files: IUploadFile[], eInvSupplier: number) {
    const formData = new FormData();
    formData.append("data", JSON.stringify(vnpayInfo));
    formData.append("e_inv_supplier", eInvSupplier.toString());

    files.forEach(file => {
      if (file.file) {
        formData.append(file.code, file.file);
      }
    });

    const res = await client.post("/pharmacy/invoice/einvoice/register", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return res.data;
  }
}